import type { ResolvedConfig } from '@nvd/claim-shared';
import { useEffect, useState } from 'react';
import type { Api } from './api/client';
import { applyTheme } from './boot/theme';
import { loadConfig } from './boot/loadConfig';
import { Spinner } from './components/Spinner';
import { UI } from './lib/ui';
import { Portal } from './Portal';

type Boot = { status: 'loading' } | { status: 'error' } | { status: 'ready'; config: ResolvedConfig; api: Api };

export function App({ root }: { root: HTMLElement }) {
  const [boot, setBoot] = useState<Boot>({ status: 'loading' });

  useEffect(() => {
    loadConfig(root)
      .then(({ config, api }) => {
        applyTheme(root, config);
        setBoot({ status: 'ready', config, api });
      })
      .catch(() => setBoot({ status: 'error' }));
  }, [root]);

  if (boot.status === 'loading') {
    return (
      <div className="nvd-claim-portal__boot">
        <Spinner />
      </div>
    );
  }
  if (boot.status === 'error') {
    return <p className="nvd-claim-portal__boot nvd-claim-portal__error">{UI.loadError}</p>;
  }
  return <Portal config={boot.config} api={boot.api} />;
}
